<template>
  <div class="base">
    <inside-header title="我的孩子" />
    <van-form @submit="OnSubmit">
      <van-field v-model="username" name="nick_name" label="姓名" placeholder="请输入姓名"
        :rules="[{ required: true, message: '请输入姓名' }]" />
      <van-field readonly clickable label="性别" name="sex" :value="sex" placeholder="请选择性别" @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
      <van-field v-model="subject" name="coach_subject" label="科目" placeholder="请输入科目" />
      <van-field readonly clickable label="所在阶段" name="stage" :value="stage" placeholder="点击选择阶段"
        :rules="[{ required: true, message: '点击选择所在阶段' }]" @click="showStage = true" />
      <van-popup v-model="showStage" position="bottom">
        <van-picker show-toolbar :columns="studentStage" @confirm="onStudentStage" @cancel="showStage = false" />
      </van-popup>
      <van-field v-model="message" rows="2" autosize label="描述信息" type="textarea" maxlength="150" placeholder="请输入描述信息"
        show-word-limit />
      <van-field v-model="required" rows="2" autosize label="对教员的要求" type="textarea" maxlength="150"
        placeholder="对教员的要求" show-word-limit />
      <div style="margin-top:50px;text-align:center">
        <van-button v-if="pageType == 'add'" color="#ff5c00" native-type="submit"
          style="width:315px;border-radius:10px;">
          添加
        </van-button>
        <van-button v-else color="#ff5c00" native-type="submit" style="width:315px;border-radius:10px;">
          保存
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'UserAddChild1',
  components: {
    InsideHeader
  },
  props: {
    id: {}
  },
  data() {
    return {
      username: '',
      sex: '',
      columns: ['男', '女'],
      showPicker: false,
      subject: '',
      studentStage: ['小学', '初一二', '初三', '高一二', '高三'],
      stage: '',
      showStage: false,
      message: '',
      required: '',
      pageType: 'add'
    }
  },
  created() {
    if (this.id !== undefined && this.id !== '') {
      this.pageType = 'edit'
      this.loadData(this.id)
    }
  },
  methods: {
    loadData(id) {
      this.$http({
        url: 'index/user/student',
        method: 'get',
        params: {
          id: id
        }
      }).then(res => {
        console.log(res)
        var data = res.data
        var info = data.info
        this.username = info.nick_name
        this.subject = info.coach_subject
        this.sex = info.sex
        this.message = info.desc
        this.required = info.require_desc
        this.stage = info.stage
      })
    },
    onConfirm(value) {
      this.sex = value
      this.showPicker = false
    },
    onStudentStage(stage) {
      this.stage = stage
      this.showStage = false
    },
    OnSubmit(values) {
      var url = ''
      if (this.pageType === 'add') {
        url = 'index/user/studentCreate'
      } else {
        url = 'index/user/studentSave'
        values.id = this.id
      }
      this.$http({
        url: url,
        method: 'post',
        data: values
      }).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'UserStudents' })
        } else {
          this.$toast.fail(res.message)
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>

</style>
